import React from "react";
import { ToastContainer } from "react-toastify";
import "../../../business-types/laundry/modules/home/Home.css";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import { useTimeZones } from "../hooks/useTimeZones";
import { useSignupForm } from "../hooks/useSignupForm";
import { useSignupHandler } from "../hooks/useSignupHandler";
import { GenericForm } from "../components/GenericForm";
import LoadingScreen from "../../../shared/components/LoadingScreen";
import { FormErrors, SignupFormData } from "../types/authTypes";
import { signupFormSchema } from "../schemas/signupFormSchema";

const Signup: React.FC = () => {
  useDocumentTitle("Signup - iMetanic");

  const { formData, errors, inputValue, updateField, handleEmailChange, handleDobChange, handlePhoneChange, setError, clearError } = useSignupForm();

  const { timeZones, loading: timeZonesLoading } = useTimeZones();

  const { loading, isFormValid, handleRegister } = useSignupHandler({
    formData,
    setError,
    clearError,
  });

  return (
    <div className="signall">
      <ToastContainer />

      {/* 🎨 Top Banner */}
      <div className="colarcontainer-1" />

      <div className="Container1">
        <div className="overview">
          <h1 className="text-3xl font-bold mb-2">Get Started</h1>

          {/* 📝 Generic Form */}
          <GenericForm<SignupFormData, FormErrors>
            schema={signupFormSchema}
            formData={formData}
            errors={errors}
            updateField={updateField}
            clearError={clearError}
            handleEmailChange={handleEmailChange}
            handleDobChange={handleDobChange}
            handlePhoneChange={handlePhoneChange}
            timeZones={timeZones}
            timeZonesLoading={timeZonesLoading}
            inputValue={inputValue}
          />

          {/* 🔘 Action Button */}
          <div className="signbtns">
            <button className="btns1" onClick={handleRegister} disabled={!isFormValid || loading} style={{ backgroundColor: !isFormValid ? "#96bbe8" : undefined }}>
              {loading ? "Signing up..." : "Signup"}
            </button>
          </div>

          {/* ❌ General Errors */}
          {errors.general && <p className="text-red-500 text-center mt-2">{errors.general}</p>}
        </div>
      </div>

      {/* ⏳ Loading Overlay */}
      {loading && <LoadingScreen />}
      <div className="Colorcontainer" />
    </div>
  );
};

export default Signup;
